import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import { StockCalendarCell } from 'components/Calendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getClosedDates, getSpecialHolidays } from 'reducks/calendar/selectors'
import { dateToString } from 'lib/helper'
import { SpecialHolidayType } from 'types/calendar'

type Props = {
  currentDate: Date
  handleCurrentDate: (date: Date) => void
  row: Date[]
}

const StockCalendarRow: FC<Props> = (props) => {
  const { currentDate, handleCurrentDate, row } = props

  const closedDates = useSelector((state: State) => getClosedDates(state))
  const specialHolidays: SpecialHolidayType[] = useSelector((state: State) => getSpecialHolidays(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = isSameDay(currentDate, date)
        const isClosed = closedDates.some((disabledDate) => isSameDay(disabledDate, date))
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))

        return (
          <StockCalendarCell
            key={getDate(date)}
            currentDate={currentDate}
            date={date}
            handleCurrentDate={handleCurrentDate}
            isActive={isActive}
            isSpecialHoliday={isSpecialHoliday}
            isClosed={isClosed}
          />
        )
      })}
    </tr>
  )
}

export default StockCalendarRow
